import { call, put, takeEvery } from 'typed-redux-saga'
import { tariffsBlockApi, TariffsNS, tariffsSlice } from 'Pages/registratorCabinet'
import { loadersSlice } from 'Modules'

export function* getRegions() {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(tariffsBlockApi.getRegions)
		yield* put(tariffsSlice.actions.setRegions(res))
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* getBusinessApp(action: TariffsNS.GetBusinessApp) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(tariffsBlockApi.getBusinessApp, action.payload)
		yield* put(tariffsSlice.actions.setBusinessApp(res?.entries[0]))
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* getDivisions(action: TariffsNS.GetDivisions) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(tariffsBlockApi.getDivisions, action.payload)
		yield* put(tariffsSlice.actions.setDivisions(res))
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* tariffsSaga() {
	yield* takeEvery(tariffsSlice.actions.getDivisions.type, getDivisions)
	yield* takeEvery(tariffsSlice.actions.getRegions.type, getRegions)
	yield* takeEvery(tariffsSlice.actions.getBusinessApp.type, getBusinessApp)
}
